export default __webpack_public_path__ + "static/media/ff-mark-pro.5879ecab.woff";